import { render, staticRenderFns } from "./historyQuestion.vue?vue&type=template&id=00ece3e8&scoped=true&"
import script from "./historyQuestion.js?vue&type=script&lang=js&"
export * from "./historyQuestion.js?vue&type=script&lang=js&"
import style0 from "./historyQuestion.css?vue&type=style&index=0&id=00ece3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ece3e8",
  null
  
)

export default component.exports